/**
 * Action and mutation types for wordpress/media module
 */
const types = {
  FETCH: 'fetch',
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete'
}

export default types



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/media/types.js